<app-tablepage-base [loading]="loading">
  <p-table [value]="users"
           [paginator]="true" [rows]="25" [rowsPerPageOptions]="[10, 25, 50]"
           [scrollable]="true" scrollHeight="flex"
           [globalFilterFields]="['name']"
           stripedRows
           #dt
           class="flex h-full min-h-0 flex-col">
    <ng-template #caption>
      <div class="flex items-center justify-between">
        <span class="text-xl font-bold">{{ 'titles.listPatient' | translate }}</span>
        <div class=" inline-flex gap-2">
          <div class="flex">
            <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="{{ 'search' | translate }}..." />
          </div>
          <!--<p-button variant="outlined" icon="pi pi-user-plus" [label]="'newUser' | translate" (click)="onShowDialog(newUser)" />-->
        </div>
      </div>
    </ng-template>
    <ng-template #header>
      <tr class="text-sm" app-patient-header [showSteps]="true" [showStatus]="true"></tr>
    </ng-template>
    <ng-template #body let-user>
      <tr app-patient-row [user]="user" [messageService]="messageService" [routerService]="routerService" [showSteps]="true" [showStatus]="true"></tr>
    </ng-template>
  </p-table>
</app-tablepage-base>
